// extracted by mini-css-extract-plugin
export default {"mainContainer":"errorMessage_mainContainer__PhUl2","contentBox":"errorMessage_contentBox__Ta1MT","text":"errorMessage_text__AAMVY","reloadButton":"errorMessage_reloadButton__Q7AQN"};